import { render, staticRenderFns } from "./multipleTopic.vue?vue&type=template&id=2b950da8&scoped=true"
import script from "./multipleTopic.vue?vue&type=script&lang=js"
export * from "./multipleTopic.vue?vue&type=script&lang=js"
import style0 from "./multipleTopic.vue?vue&type=style&index=0&id=2b950da8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b950da8",
  null
  
)

export default component.exports